import { START_LOADING_PAGE_DATA, STOP_LOADING_PAGE_DATA } from "./actionTypes";

export function startLoadingPageData() {
  return { type: START_LOADING_PAGE_DATA }
}

export function stopLoadingPageData() {
  return { type: STOP_LOADING_PAGE_DATA }
}